import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const DESTINATIONS = { disco: 'Disco', cloud: 'Cloud', cinta: 'Cinta' };
export const UNITS = { dias: 'días', semanas: 'semanas', meses: 'meses', anos: 'años', puntos: 'puntos de restauración' };
export const STATUSES = { protegido: 'Declarado protegido', pendiente: 'Pendiente', excepcion: 'Excepción' };

export const Choice = ({ value, onChange, choices, placeholder = 'Seleccionar...', disabled = false }) => (
  <Select value={String(value || '')} onValueChange={onChange} disabled={disabled}>
    <SelectTrigger><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      {Object.entries(choices).map(([key, label]) => <SelectItem key={key} value={key}>{label}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const describeRetention = (retention) => (
  `${DESTINATIONS[retention.destination] || retention.destination}: ${retention.retention_quantity} ${UNITS[retention.retention_unit] || retention.retention_unit} · ${retention.copy_frequency}`
  + (retention.repository ? ` · ${retention.repository}` : '')
  + (retention.immutability_days != null ? ` · inmutabilidad ${retention.immutability_days} días` : '')
);

export const errorMessage = (error, fallback) => (
  typeof error.response?.data?.detail === 'string' ? error.response.data.detail : fallback
);
